import script from "./ContactTurtles.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactTurtles.vue?vue&type=script&setup=true&lang=js"

import "./ContactTurtles.vue?vue&type=style&index=0&id=60d0cc1f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60d0cc1f"]])

export default __exports__